/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 1/7/16.
 */
'use strict';
angular.module('prism-ui.content')
    .service('ContentSearchService', function (this: JS5Object, PaginationService: JS5Object,
                                               uiGridConstants: JS5Object, ContentResourceFactory: JS5Object) {

        const handleGridDataQuery = (gridData, responseHeaders) => {
            PaginationService.parseResponseHeaders(responseHeaders());
            PaginationService.pageData = gridData;
            this.currentPageSize = gridData.length;
        };

        this.getSearchViewData = (criteria) => {
            this.breadcrumbName = '';
            return ContentResourceFactory.query(criteria, handleGridDataQuery).$promise;
        };

        this.toggleContentHidden = (id: string) => {
            return ContentResourceFactory.toggleArchive({id: id}).$promise;
        };

        _.set(this, 'Ad/PreRollColumnDefs', [
            {
                field: 'locked',
                name: 'lockColumn',
                displayName: '',
                width: 25,
                enableColumnMenu: false,
                enableSorting: false,
                cellTemplate: 'components/visual/grid/lock-icon-template.html',
                headerCellTemplate: 'components/visual/grid/header-lock-icon-template.html'
            },
            {
                field: 'name',
                name: 'Name',
                minWidth: 250,
                sort: {
                    direction: uiGridConstants.ASC,
                    priority: 0
                },
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            }

        ]);

        _.set(this, 'SeriesColumnDefs', [
            {
                field: 'locked',
                name: 'lockColumn',
                displayName: '',
                width: 25,
                enableColumnMenu: false,
                enableSorting: false,
                cellTemplate: 'components/visual/grid/lock-icon-template.html',
                headerCellTemplate: 'components/visual/grid/header-lock-icon-template.html'
            },
            {
                field: 'name',
                name: 'Name',
                minWidth: 250,
                sort: {
                    direction: uiGridConstants.ASC,
                    priority: 0
                },
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            },
            {
                field: 'value',
                name: 'Value',
                minWidth: 250,
                sortable: false,
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            },
            {
                field: 'prefix',
                name: 'Prefix',
                width: 110,
                sortable: false,
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            },
            {
                field: 'airTime',
                name: 'Airtime',
                width: 110,
                sortable: false,
                cellTemplate: 'components/visual/grid/time-column-template.html'
            },
            {
                field: 'genre.name',
                name: 'Genre',
                minWidth: 200,
                sortable: false,
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            },
            {
                field: 'shortDescription',
                name: 'Description 1',
                minWidth: 1500,
                sortable: false,
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            }
        ]);
        _.set(this, 'Movie/SpecialColumnDefs', [
            {
                field: 'locked',
                name: 'lockColumn',
                displayName: '',
                width: 25,
                enableColumnMenu: false,
                enableSorting: false,
                cellTemplate: 'components/visual/grid/lock-icon-template.html',
                headerCellTemplate: 'components/visual/grid/header-lock-icon-template.html'
            },
            {
                field: 'name',
                name: 'Name',
                minWidth: 250,
                sort: {
                    direction: uiGridConstants.ASC,
                    priority: 0
                },
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            },
            {
                field: 'value',
                name: 'Value',
                minWidth: 250,
                sortable: false,
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            },
            {
                field: 'prefix',
                name: 'Prefix',
                width: 200,
                sortable: false,
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            },
            {
                field: 'shortDescription',
                name: 'Description 1',
                minWidth: 110,
                sortable: false,
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            },
            {
                field: 'genre.name',
                name: 'Genre',
                minWidth: 200,
                sortable: false,
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            }
        ]);
    });
